import { useStyletron } from '@thanx/uikit/theme'
import ProtectedPageHeader from 'components/ProtectedPageHeader'
import useCurrentMerchant from 'hooks/useCurrentMerchant'
import { useReportPermission } from 'hooks/useReportPermission'
import { buildTranslate } from 'locales'
import React from 'react'
import { Container } from 'react-bootstrap-five'
import Helmet from 'react-helmet'
import { I18n } from 'react-redux-i18n'
import LookerFooter from 'scenes/LookerEmbed/components/LookerFooter'
import LookerIframe from 'scenes/LookerEmbed/LookerIframe'

const t = buildTranslate('looker')

const MembershipOverviewReport: React.FC = () => {
  const merchant = useCurrentMerchant()
  const [css] = useStyletron()
  const reportPermission = useReportPermission({
    rbac: 'Reports',
    legacy: 'LocationReports',
  })

  if (!merchant) return null

  const title = t('urls.dashboards/131.title')
  const height = 1850

  return (
    <ProtectedPageHeader
      title={title}
      description=""
      resource={reportPermission.resource}
      action={reportPermission.action}
    >
      <Helmet>
        <title>{I18n.t('titles./reports/membershipoverview')}</title>
      </Helmet>
      <div
        className={`grey-05-bkg border-top-1 pb-l grey-20-border ${css({
          minHeight: `calc(100% - 50px)`,
        })}`}
      >
        <Container
          className={`px-0 ${css({
            minHeight: `${height + 300}px`,
          })}`}
        >
          <LookerIframe
            path={'dashboards/131'}
            merchant={merchant}
            height={`${height}px`}
          />
          <LookerFooter className="my-xl" />
        </Container>
      </div>
    </ProtectedPageHeader>
  )
}

export default MembershipOverviewReport
